<template>
  <div :class="isMobile ? 'place-m' : 'place'">
    <div class="circle-box">
      <img src="./../../assets/about/round.png" class="circle-img" />
      <div class="circle-container">
        <div class="rotating-div circle-one" v-for="(item, index) in placeList" :key="index" >
          <div class="leftbox">
            <img :src="item.url" class="circle-one-img" v-show="isMobile" />
          </div>
          <div class="rightbox">
            <SlideUpComponent :offset="20" :once="false">
              <div class="circle-one-text">{{ item.text }}</div>
            </SlideUpComponent>
            <SlideUpComponent :offset="20" :once="false">
              <div class="circle-one-detail">{{ item.detail }}</div>
            </SlideUpComponent>
          </div>
        </div>
      </div>
    </div>
    <div class="btnlist" ref="overviewRef">
      <div :class="currentIndex==index ? 'active btn-one': 'btn-one' " 
          v-for="(item, index) in placeList" :key="index" 
          @click="changeCutIndex(index)">
        {{ item.text }}
      </div>
    </div>
    <div>
      <div class="btn-one-title">
        <img :src="placeList[currentIndex].bgimg" class="big-bg" />
        <SlideUpComponent :offset="40" :trigger="currentIndex">
          <div class="btn-one-text">{{ placeList[currentIndex].text }}</div>
        </SlideUpComponent>
        <SlideUpComponent :offset="60" :trigger="currentIndex">
          <div class="btn-one-detail">{{ placeList[currentIndex].detail }}</div>
        </SlideUpComponent>
      </div>
      <el-row :gutter="isMobile?0:20">
        <el-col :span="isMobile?24:12" v-for="(item, index) in placeList[currentIndex].content" :key="index">
          <div  class="btn-one-one">
            <img :src="item.url" class="btn-one-one-img" />
            <div class="btn-one-one-name">{{ item.name }}</div>
            <div class="btn-one-one-text">{{ item.text }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import imgUrl from "@/utils/imgUrl"
  import SlideUpComponent from '@/components/SlideUpComponent.vue'
  import * as L from "leaflet";
  import "leaflet/dist/leaflet.css";
  import arrJson from "@/utils/arrJson";

  // 解决 leaflet 默认 maker 无法显示的问题
  let DefaultIcon = L.icon({
    // iconUrl: require("images/ico_xm_0-50.png"),
    iconUrl: require("@/assets/icon/ico_dw.png"),
    iconSize: [23, 30], // 加上，fixed marker在放缩5 时偏差比较大的问题
    iconAnchor: [3, 40],
    popupAnchor: [0, -50]
  });
  L.Marker.prototype.options.icon = DefaultIcon;


  export default {
    name: 'Place',
    components: {
      SlideUpComponent
    },
    data() {
      return {
        imgUrl,
        isMobile: window.innerWidth < 780,
        username: "",
        userphone: "",
        userText: "",
        currentIndex: 1,
        placeList: arrJson.placelist
      }
    },
    props: {
      msg: String
    },
    mounted() {
      window.addEventListener("resize", this.initFunc)
      // this.setmap()
      this.init()
    },
    destroyed() {
      window.removeEventListener("resize", this.initFunc)
    },
    methods: {
      init(){
        const placeId = window.sessionStorage.getItem('placeId');
        console.log("placeId", placeId)
        if(placeId && placeId>=0 && placeId<=this.placeList.length){
          this.currentIndex = placeId
          const element = this.$refs.overviewRef
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            })
          }
          window.sessionStorage.removeItem("placeId")
        }
      },
      changeCutIndex(i){
        this.currentIndex = i
      },
      initFunc() {
        this.isMobile = window.innerWidth < 780
      }
    }
  }
</script>
  
  <style lang="less">
    .leaflet-bottom{
      opacity: 0;
      z-index: -1;
    }
    .el-input /deep/ .el-input__inner{
      border: none;
      height: 38px;
      line-height: 38px;
    }
    .el-textarea /deep/ .el-textarea__inner{
      border: none;
    }
    p{
      margin: 0;
    }
    .place{
      max-width: 1400px;
      margin: 0 auto;
      .circle-box{
        width: 1400px;
        margin: 250px auto 50px;
        .circle-img{
          width: 830px;
          height: 800px;
          position: absolute;
          left: 50%;
          margin-left: -400px;
        }
        .circle-container {
          position: relative;
          height: 1000px;
          width: 1400px;
          .rotating-div {
            position: absolute;
            width: 260px;
            height: 180px;
            font-size: 24px;
            transition: transform 0.3s ease;
            .circle-one-text{
              font-size: 20px;
              font-weight: bold;
              line-height: 40px;
            }
            .circle-one-detail{
              font-size: 14px;
              color: #989898;
            }
          }
          /* 圆形排列的8个DIV - 使用transform进行定位 */
          .rotating-div:nth-child(1) { transform: translate(90px, 50px); }
          .rotating-div:nth-child(2) { transform: translate(30px, 350px); }
          .rotating-div:nth-child(3) { transform: translate(600px, -130px); }
          .rotating-div:nth-child(4) { transform: translate(1060px, 50px); }
          .rotating-div:nth-child(5) { transform: translate(1150px, 350px); }
          .rotating-div:nth-child(6) { transform: translate(130px, 580px); }
          .rotating-div:nth-child(7) { transform: translate(1100px, 580px); }
          .rotating-div:nth-child(8) { transform: translate(600px, 800px); }
        }
      }
      .btnlist{
        .btn-one{
          background-color: #CFF7FF;
          border-radius: 20px;
          padding: 14px 45px;
          display: inline-block;
          margin: 10px;
          box-shadow: 2px 4px 4px #00000030;
          cursor: pointer;
        }
        .active{
          background-color: #384C5C;
          color: #fff;
          box-shadow: none;
        }
      }
      .btn-one-title{
        position: relative;
        border-radius: 20px;
        height: 346px;
        margin: 40px 0;
        padding: 4.2%;
        box-sizing: border-box;
        .big-bg{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          // height: 346px;
          z-index: -1;
        }
        .btn-one-text{
          color: #fff;
          font-size: 28px;
          line-height: 68px;
        }
        .btn-one-detail{
          color: #fff;
          width: 60%;
          font-size: 17px;
        }
      }
      .btn-one-one{
        border-radius: 20px;
        background-color: #F3F3F5;
        padding: 4.4% 0;
        box-sizing: border-box;
        margin: 20px 0;
        height: 240px;
        text-align: center;
        .btn-one-one-img{
          display: inline-block;
          margin: 0 auto;
          width: 40px;
          height: 40px;
        }
        .btn-one-one-name{
          font-size: 20px;
          line-height: 50px;
          text-align: center;
          color: #000;
        }
        .btn-one-one-text{
          padding: 0 15%;
          line-height: 26px;
          color: #989898;
        }
      }
      .word{
        .word-title{
          line-height: 44px;
          font-size: 32px;
          margin-top: 60px;
          font-weight: bold;
          text-align: center;
          color: #313E47;
        }
        .word-text{
          color: #313E47;
          font-size: 16px;
          line-height: 26px;
          font-weight: normal;
          text-align: center;
        }
      }
    }
    .place-m{
      margin: 0 auto;
      .circle-box{
        width: 90%;
        margin: 1rem auto 1rem;
        display: none;
        .circle-img{
          display: none;
        }
        .circle-container {
          position: relative;
          width: 90%;
          .rotating-div {
            font-size: 0.48rem;
            transition: transform 0.3s ease;
            text-align: center;
            .circle-one-img{
              width: 2rem;
            }
            .leftbox{
              width: 30%;
              display: inline-block;
              margin-bottom: 0.4rem;
              vertical-align: middle;
            }
            .rightbox{
              width: 70%;
              display: inline-block;
            }
            .circle-one-text{
              font-size: 0.4rem;
              font-weight: bold;
              line-height: 0.8rem;
              text-align: left;
            }
            .circle-one-detail{
              text-align: left;
              font-size: 0.28rem;
              color: #989898;
            }
          }
        }
      }
      .btnlist{
        width: 90%;
        margin: 0.4rem auto 0;
        .btn-one{
          background-color: #CFF7FF;
          border-radius: 0.4rem;
          padding: 0.2rem 0.64rem;
          display: inline-block;
          margin: 0.1rem;
          box-shadow: 0.04rem 0.08rem 0.08rem #00000030;
          cursor: pointer;
          font-size: 0.36rem;
        }
        .active{
          background-color: #384C5C;
          color: #fff;
          box-shadow: none;
        }
      }
      .btn-one-title{
        position: relative;
        margin: 0.8rem auto 0.6rem;
        padding: 0.4rem 0.8rem;
        box-sizing: border-box;
        width: 96%;
        border-radius: 0.4rem;
        overflow: hidden;
        .big-bg{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 4.8rem;
          z-index: -1;
        }
        .btn-one-text{
          color: #fff;
          font-size: 0.56rem;
          line-height: 1.36rem;
        }
        .btn-one-detail{
          color: #f3f3f3;
          width: 60%;
          font-size: 0.3rem;
          line-height: 0.5rem;
        }
      }
      .btn-one-one{
        border-radius: 0.4rem;
        background-color: #F3F3F5;
        padding: 0.4rem 0;
        box-sizing: border-box;
        // margin: 0.3rem 0;
        // height: 4.8rem;
        width: 96%;
        margin: 0 auto 0.6rem;
        .btn-one-one-img{
          width: 1.2rem;
          height: 1.2rem;
          margin: 0 auto;
          display: block;
        }
        .btn-one-one-name{
          font-size: 0.4rem;
          line-height: 0.8rem;
          text-align: center;
          color: #000;
        }
        .btn-one-one-text{
          padding: 0 0.4rem;
          line-height: 0.5rem;
          font-size: 0.24rem;
        }
      }
      .word{
        .word-title{
          font-size: 0.5rem;
          line-height: 0.6rem;
          font-weight: bold;
          color: #333333;
          letter-spacing: 0.05rem;
          margin: 0.4rem 0 0;
          text-align: center;
        }
        .word-text{
          font-size: 0.32rem;
          line-height: 0.6rem;
          color: #758292 ;
          text-align: center;
        }
      }
    }
  </style>